// extracted by mini-css-extract-plugin
export default {"error":"UserAsignations_error__+sOvW","searchForm":"UserAsignations_searchForm__0oKx4","icon":"UserAsignations_icon__h2hVn"};